// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"532f3065","213":"14e54230","453":"b82b5883"}[chunkId] + ".chunk.js";
};